import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle as MdErrorOutline } from "lucide-react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error caught by ErrorBoundary:", error, info);
    // TODO: send error to tracking service (Sentry, Datadog, etc.)
  }

  handleRetry = () => {
    this.setState({ hasError: false });
    window.location.reload(); // or re-mount children
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
          <Card className="shadow-2xl rounded-2xl max-w-md w-full">
            <CardContent className="flex flex-col items-center text-center p-8">
              <MdErrorOutline className="text-red-500 text-6xl mb-4" />
              <h2 className="text-2xl font-semibold mb-2 text-gray-800">
                Oops! Something went wrong
              </h2>
              <p className="text-gray-600 mb-6">
                An unexpected error occurred. Please try again or contact
                support if the issue persists.
              </p>
              <Button onClick={this.handleRetry}>Retry</Button>
            </CardContent>
          </Card>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
